export default  {
    component: 'mppt_zone_status',
    name: 'mppt_zone_status',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            param: 'block_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            param: 'room_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            param: 'inverter_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            param: 'scb_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Channels',
            param: 'channels',
            type: 'text'
          },
          {
            name: 'Module',
            param: 'module',
            type: 'text'
          }
  // device_id
  // inverter_name
  // added_on
  // updated_on
  // updated_by
  // inverter_room
    ]
  }
